export const trending = [
  {
    "id": "18",
    "name": "Flowy Maxi Dress",
    "description": "Make a statement with our flowy maxi dress.",
    "brand": "SunnyStyle",
    "size1": "XS",
    "size2": "S",
    "size3": "M",
    "size4": "L",
    "color1": "Coral",
    "color2": "Yellow",
    "image": "Flowy Maxi Dress.avif",
    "price": "4379"
  },
  {
    "id": "1",
    "name": "Cozy Knit Sweater",
    "description": "Stay warm and stylish with our cozy knit sweater.",
    "brand": "WarmWool",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "size4": "XL",
    "color1": "Darkslategray",
    "color2": "Tomato",
    "image": "Cozy Knit Sweater.jpg",
    "price": "3649"
  },
  {
    "id": "21",
    "name": "Wollen Sweater",
    "description": "wollen Sweater made from wool and with inner attached in it",
    "brand": "ShadeMaster",
    "size1": "One Size",
    "color1": "Black",
    "color2": "Tortoise",
    "image": "cap.avif",
    "price": "1019"
  },
  {
    "id": "10",
    "name": "Snow Boots",
    "description": "Conquer the snow with our durable and waterproof snow boots.",
    "brand": "SnowMaster",
    "size1": "US 6-12",
    "color1": "Teal",
    "color2": "Gold",
    "image": "Snow Boots.jpg",
    "price": "4379"
  }
];
